export const WordLogoOld = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 1214.29 213.66"
    style={{
      enableBackground: 'new 0 0 1214.29 213.66',
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.st0{fill-rule:evenodd;clip-rule:evenodd}'}</style>
    <switch>
      <g>
        <path
          d="m450.93 206.22-6.98-24.84c-15.35 20.93-40.48 29.59-63.92 29.59-59.46 0-94.91-48.57-94.91-100.49 0-58.06 31.82-108.31 94.91-108.31 43.55 0 78.16 19.54 85.7 66.16H439.2c-5.3-30.15-29.59-43.83-59.18-43.83-48.29 0-68.39 41.87-68.39 84.58 0 41.59 24.01 79.55 68.39 79.55 41.03 0 65.6-28.75 63.92-65.04H380.3v-22.33h87.37v104.96h-16.74zM483.29 166.58c0-30.7 18.42-47.45 84.3-47.45 4.19 0 8.65.28 13.12.28v-10.33c0-23.45-13.68-29.59-33.5-29.59-20.1 0-33.22 6.14-34.33 27.36h-24c1.39-35.73 28.75-48.29 58.34-48.29 29.31 0 56.94 12.56 56.94 46.34v80.39h15.91v20.93h-22.05l-17.86-17.59c-12.84 13.96-29.87 20.66-49.13 20.66-26.25 0-47.74-15.63-47.74-42.71m86.25-29.87c-53.04 0-61.13 11.72-61.13 28.19 0 15.63 13.4 23.73 27.91 23.73 31.26 0 44.38-19.54 44.38-32.66v-18.98c-3.9 0-7.53-.28-11.16-.28M654.66 61.9l1.12 21.22h.56c10.61-16.19 26.8-24.57 46.62-24.57 17.59 0 33.78 6.98 39.64 24.57 9.77-15.35 26.8-24.57 45.22-24.57 28.75 0 48.01 12 48.01 41.87v105.79H812.1v-94.63c0-17.86-4.75-32.1-27.91-32.1-22.89 0-37.68 14.52-37.68 36.85v89.88h-23.73v-94.63c0-18.7-5.86-32.1-27.08-32.1-28.19 0-38.52 25.96-38.52 36.85v89.88h-23.73V61.9h21.21zM880.19 61.9l1.12 21.22h.56c10.61-16.19 26.8-24.57 46.62-24.57 17.59 0 33.78 6.98 39.64 24.57 9.77-15.35 26.8-24.57 45.22-24.57 28.75 0 48.01 12 48.01 41.87v105.79h-23.73v-94.63c0-17.86-4.75-32.1-27.91-32.1-22.89 0-37.68 14.52-37.68 36.85v89.88h-23.73v-94.63c0-18.7-5.86-32.1-27.08-32.1-28.19 0-38.52 25.96-38.52 36.85v89.88h-23.73V61.9h21.21zM1077.51 166.58c0-30.7 18.42-47.45 84.3-47.45 4.19 0 8.65.28 13.12.28v-10.33c0-23.45-13.68-29.59-33.5-29.59-20.1 0-33.22 6.14-34.33 27.36h-24c1.39-35.73 28.75-48.29 58.34-48.29 29.31 0 56.94 12.56 56.94 46.34v80.39h15.91v20.93h-22.05l-17.86-17.59c-12.84 13.96-29.87 20.66-49.13 20.66-26.24 0-47.74-15.63-47.74-42.71m86.26-29.87c-53.04 0-61.13 11.72-61.13 28.19 0 15.63 13.4 23.73 27.91 23.73 31.26 0 44.38-19.54 44.38-32.66v-18.98c-3.91 0-7.53-.28-11.16-.28"
          fill="currentColor"
          shapeRendering="geometricPrecision"
        />
        <path
          className="st0"
          d="M160.97 213.13c-1.92 0-3.58-1.37-3.93-3.25l-23.2-122.26a73.062 73.062 0 0 1 1.52-27.67l20.73-57.31A4.009 4.009 0 0 1 159.86 0h47.5c3.27 0 5.16 3.71 3.24 6.35l-38.12 52.33a33.23 33.23 0 0 0-4.19 31.44l44.88 117.59c1 2.62-.94 5.42-3.74 5.42h-48.46zM2.82 6.35C.9 3.71 2.79 0 6.06 0h47.5c1.69 0 3.19 1.06 3.77 2.64l20.73 57.31a73.266 73.266 0 0 1 1.52 27.67l-23.2 122.26a3.997 3.997 0 0 1-3.93 3.25H4.01c-2.8 0-4.74-2.8-3.74-5.42L45.14 90.12a33.28 33.28 0 0 0-4.19-31.44L2.82 6.35z"
          fill="currentColor"
          shapeRendering="geometricPrecision"
        />
        <path
          className="st0"
          d="M133.62 4.97c.63-2.52-1.28-4.97-3.88-4.97H83.69c-2.6 0-4.52 2.44-3.88 4.97l12.96 51.75a86.182 86.182 0 0 1 1.79 32.7L78.28 208.59c-.33 2.4 1.54 4.54 3.97 4.54h48.93c2.43 0 4.29-2.14 3.97-4.54L118.86 89.41a86.598 86.598 0 0 1 1.79-32.7l12.97-51.74z"
          fill="currentColor"
          shapeRendering="geometricPrecision"
        />
      </g>
    </switch>
  </svg>
);

export const WordLogo = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 350 84"
    style={{
      enableBackground: 'new 0 0 350 84',
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.st0{fill-rule:evenodd;clip-rule:evenodd}.st1{enable-background:new}'}</style>
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      className="st0"
      d="M61.4 76.6c-.6 0-1.1-.4-1.2-1l-7.4-38.8c-.4-2.9-.2-5.9.5-8.8l6.6-18.2c.1-.5.6-.8 1.1-.8h15.1c1 0 1.6 1.2 1 2l-12 16.6c-2.1 2.9-2.6 6.6-1.3 10L78 74.9c.3.8-.3 1.7-1.2 1.7H61.4zM11.2 11c-.6-.8 0-2 1-2h15.1c.5 0 1 .3 1.2.8L35.1 28c.7 2.9.9 5.8.5 8.8l-7.4 38.8c-.1.6-.6 1-1.2 1H11.6c-.9 0-1.5-.9-1.2-1.7l14.2-37.3c1.3-3.3.8-7.1-1.3-10L11.2 11z"
    />
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      className="st0"
      d="M52.7 10.5c.2-.8-.4-1.5-1.2-1.5H36.9c-.8 0-1.4.8-1.2 1.6L39.8 27c.9 3.4 1 6.9.6 10.4l-5.2 37.8c-.1.8.5 1.4 1.3 1.4H52c.8 0 1.4-.7 1.3-1.4L48 37.4c-.5-3.5-.3-7 .6-10.4l4.1-16.5z"
    />
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      d="M129.2 73.5c-5.5 0-10.3-1.3-14.5-3.8-4.2-2.5-7.5-6.1-9.8-10.6-2.3-4.5-3.5-9.8-3.5-15.8s1.2-11.3 3.5-15.8c2.3-4.6 5.6-8.1 9.8-10.7 4.2-2.5 9-3.8 14.5-3.8 4.1 0 7.9.8 11.2 2.3 3.4 1.6 6.1 3.8 8.4 6.6 2.2 2.9 3.7 6.2 4.6 10.1l-6.5 1.3c-.7-2.8-1.9-5.3-3.5-7.4-1.6-2.1-3.6-3.7-6-4.9-2.4-1.1-5.1-1.7-8-1.7-4 0-7.6 1-10.7 3-3.1 2-5.6 4.8-7.3 8.4s-2.6 7.8-2.6 12.6.9 9.1 2.6 12.7c1.7 3.6 4.1 6.4 7.2 8.3 3.1 1.9 6.7 2.9 10.7 2.9 3.1 0 5.8-.6 8.2-1.8 2.4-1.2 4.4-2.9 6.1-5.1 1.6-2.2 2.8-4.6 3.4-7.4l6.6 1.2c-.8 3.8-2.3 7.2-4.4 10.1-2.2 2.9-5 5.2-8.3 6.8-3.6 1.7-7.4 2.5-11.7 2.5zM160.8 72.6V31.9h6.8v7.5h.1c1.1-2.5 2.7-4.4 4.8-5.7 2.1-1.3 4.5-2 7.4-2 .9 0 1.5 0 1.9.1v6.5c-.3-.1-.6-.1-.9-.1h-1c-2.5 0-4.6.5-6.5 1.5-1.8 1-3.3 2.5-4.3 4.4-1 1.9-1.5 4.1-1.5 6.7v21.9h-6.8zM205.2 73.5c-4 0-7.5-.9-10.4-2.7s-5.1-4.3-6.6-7.5-2.3-6.9-2.3-11.1c0-4.3.8-8.1 2.4-11.3s3.8-5.6 6.7-7.4c2.9-1.7 6.2-2.6 10-2.6 3.7 0 6.9.8 9.6 2.5 2.7 1.7 4.8 4 6.2 7 1.4 3 2.1 6.5 2.1 10.4v1.4c0 .5-.1 1.1-.1 1.7h-30.2c.2 2.9.8 5.4 1.9 7.4 1.1 2 2.6 3.6 4.4 4.7 1.9 1.1 4.1 1.6 6.7 1.6 1.8 0 3.5-.3 4.9-.9 1.5-.6 2.7-1.5 3.7-2.7 1-1.2 1.8-2.6 2.5-4.3l5.8 1.6c-.8 2.5-1.9 4.6-3.5 6.4s-3.5 3.2-5.9 4.1c-2.4 1.2-5 1.7-7.9 1.7zm11-24.8c-.1-2.5-.6-4.6-1.5-6.5s-2.2-3.4-3.9-4.4c-1.7-1-3.7-1.5-6.1-1.5-2.2 0-4.1.4-5.9 1.3-1.7.9-3.2 2.3-4.3 4.1s-1.8 4.2-2.1 7h23.8zM290.8 73c-2.7 0-4.9-.5-6.5-1.4-1.6-.9-2.8-2.2-3.6-3.8-.7-1.6-1.1-3.5-1.1-5.7V37.7h-7v-5.8h7V20.7h6.8v11.2h9.3v5.8h-9.3v24.1c0 1.6.5 2.9 1.4 3.9.9.9 2.5 1.4 4.7 1.4 1 0 2.1-.1 3.2-.2v5.5c-1.7.4-3.3.6-4.9.6zM320.3 73.5c-4 0-7.5-.9-10.4-2.7s-5.1-4.3-6.6-7.5-2.3-6.9-2.3-11.1c0-4.3.8-8.1 2.4-11.3s3.8-5.6 6.7-7.4c2.9-1.7 6.2-2.6 10-2.6 3.7 0 6.9.8 9.6 2.5 2.7 1.7 4.8 4 6.2 7 1.4 3 2.1 6.5 2.1 10.4v1.4c0 .5-.1 1.1-.1 1.7h-30.2c.2 2.9.8 5.4 1.9 7.4 1.1 2 2.6 3.6 4.4 4.7 1.9 1.1 4.1 1.6 6.7 1.6 1.8 0 3.5-.3 4.9-.9 1.5-.6 2.7-1.5 3.7-2.7 1-1.2 1.8-2.6 2.5-4.3l5.8 1.6c-.8 2.5-1.9 4.6-3.5 6.4s-3.5 3.2-5.9 4.1c-2.4 1.2-5 1.7-7.9 1.7zm11-24.8c-.1-2.5-.6-4.6-1.5-6.5s-2.2-3.4-3.9-4.4c-1.7-1-3.7-1.5-6.1-1.5-2.2 0-4.1.4-5.9 1.3-1.7.9-3.2 2.3-4.3 4.1s-1.8 4.2-2.1 7h23.8z"
      className="st1"
    />
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      d="M230.1 61.4c0-8.7 5.2-13.4 23.8-13.4 1.2 0 2.4.1 3.7.1v-2.9c0-6.6-3.9-8.3-9.4-8.3-5.6 0-9.4 1.7-9.7 7.7h-6.8c.4-10.1 8.1-13.6 16.4-13.6s16 3.5 16 13.1v22.7h4.5v5.9h-6.2l-5-5c-3.6 3.9-8.4 5.8-13.8 5.8-7.4 0-13.4-4.4-13.5-12.1m24.4-8.4c-14.9 0-17.2 3.3-17.2 7.9s3.8 6.7 7.9 6.7c8.8 0 12.5-5.5 12.5-9.2V53c-1.2.1-2.2 0-3.2 0"
    />
  </svg>
);

export const PlusCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-plus-circle"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="16"></line>
    <line x1="8" y1="12" x2="16" y2="12"></line>
  </svg>
);

export const CopyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-copy"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
);

export const GridIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-grid"
  >
    <rect x="3" y="3" width="7" height="7"></rect>
    <rect x="14" y="3" width="7" height="7"></rect>
    <rect x="14" y="14" width="7" height="7"></rect>
    <rect x="3" y="14" width="7" height="7"></rect>
  </svg>
);

export const SunIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-sun"
  >
    <circle cx="12" cy="12" r="5"></circle>
    <line x1="12" y1="1" x2="12" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="23"></line>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
    <line x1="1" y1="12" x2="3" y2="12"></line>
    <line x1="21" y1="12" x2="23" y2="12"></line>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
  </svg>
);

export const UserCheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-user-check"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="8.5" cy="7" r="4"></circle>
    <polyline points="17 11 19 13 23 9"></polyline>
  </svg>
);

export const ToolIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-tool"
  >
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
  </svg>
);

export const UsersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-users"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

export const HelpCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-help-circle"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);

export const CheckCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-check-circle"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

export const ClockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-clock"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

export const InfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-info"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

export const EditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-edit"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);

export const ExternalLinkIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-external-link"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    <polyline points="15 3 21 3 21 9"></polyline>
    <line x1="10" y1="14" x2="21" y2="3"></line>
  </svg>
);

export const UserIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-user"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

export const IndicatorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="green"
    stroke="green"
    stroke-width="0"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-circle"
  >
    <circle cx="12" cy="12" r="10"></circle>
  </svg>
);